import React from "react";
import { SelectInputComponent } from "../../../../common/components";
import { LEAD_SOURCE_OPTIONS } from "../../../../constants/leadDropdown";
import "./filter-options-select.scss"
interface LeadSourceFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
  isLeadSourceEnabled?: boolean;
  leadSourceError?: any;
}

const LeadSourceFilter: React.FC<LeadSourceFilterProps> = ({
  value,
  onChange,
  isLeadSourceEnabled,
  leadSourceError
}) => {
  if (!isLeadSourceEnabled) return null;


  return (
    <div className="filter-select-input-wrapper" >
      <SelectInputComponent
        fieldName="source"
        options={LEAD_SOURCE_OPTIONS}
        onChange={onChange}
        value={value}
        placeholder=" Select Lead Source"
        multiple={true}
        isFilter={true}
      />
      {leadSourceError && <div className="error-text">{leadSourceError}</div>}
    </div>
  );
};

export default LeadSourceFilter;
